export const MEDIA = {
  small: `@media(max-width: 600px)`,
  medium: `@media(min-width: 600px)`,
  big: `@media(min-width: 992px)`,
};
